import React from 'react';
import { Formik } from 'formik';
import { useToast } from '@chakra-ui/react';
import { omit } from 'ramda';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { localise, templateReplace } from '../../../services/lang/lang';
import SuspenseWrapper from '../../modules/SuspenseWrapper/SuspenseWrapper';
import { useRemoteSubmissionContext } from './RemoteSubmissionProvider';
import RemoteSubmissionFormWrapper from './RemoteSubmissionFormWrapper';
import FormikModalErrorSync from '../../modules/Modal/FormikModalErrorSync';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { queryClient } from '../../../services/api/query/queryClient';
import { getGetAllLocationsForRemoteSubmissionQueryKey, getGetInspectionRemoteSubmissionLocationsQueryKey, } from '../../../services/api/generated/client';
import { storeLocalPreviewUrls } from '../../../services/photos/remoteSubmissionMediaCache';
import { useCreateRemoteSubmission, } from '../../../services/api/query/useCreateRemoteSubmission';
const CreateRemoteSubmissionWrapper = ({ onSubmitComplete }) => {
    const { token } = useRemoteSubmissionContext();
    const createRemoteSubmission = useGenericMutationUseCase(useCreateRemoteSubmission);
    const toast = useToast();
    const initialValues = {
        locationSelection: undefined,
        location_name: undefined,
        elements: [],
        description: '',
        media: [],
    };
    const onSubmit = (values, helpers) => {
        const { locationSelection } = values;
        const data = {
            ...omit(['locationSelection'], values),
            ...(locationSelection && {
                [locationSelection.key]: locationSelection.id,
            }),
        };
        createRemoteSubmission.execute({
            token,
            data,
        }, helpers, {
            onSuccess: async (response) => {
                const remoteSubmission = unwrapModel(response);
                if (!remoteSubmission)
                    return;
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getGetInspectionRemoteSubmissionLocationsQueryKey(remoteSubmission.contact.inspection_id),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getGetAllLocationsForRemoteSubmissionQueryKey(token),
                    }),
                ]);
                storeLocalPreviewUrls(remoteSubmission.id, values.media);
                helpers.resetForm();
                toast({
                    title: templateReplace(localise('SUBMITTED'), {
                        noun: localise('TENANT_REPORT'),
                    }),
                    status: 'success',
                    isClosable: true,
                });
                onSubmitComplete(remoteSubmission);
            },
        });
    };
    return (React.createElement(SuspenseWrapper, null,
        React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
            React.createElement(React.Fragment, null,
                React.createElement(FormikModalErrorSync, null),
                React.createElement(RemoteSubmissionFormWrapper, null)))));
};
export default CreateRemoteSubmissionWrapper;
